import React, { Fragment } from 'react';
import { makeStyles, Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: 'smaller',
    color: theme.palette.primary.dark,
    display: 'block',
    width: '100%',
  },
  value: {
    fontSize: 'large',
    marginLeft: '5px',
  },
}));

const Field = ({ label = '', value = '' }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <label className={classes.label}> {label} </label>
        <label className={classes.value}> {value} </label>
      </Box>
    </Fragment>
  );
};

export default Field;
